import clsx from 'clsx';
import FullWrapper from 'core/FullWrapper';
import { Dispatch, SetStateAction } from 'react';

import ContactsBodyForm from '~/components/features/contacts/ContactsMain/ContactsBodyForm';
import ContactsRight from '~/components/features/contacts/ContactsMain/ContactsRight';
import ContactsRightMobile from '~/components/features/contacts/ContactsMain/ContactsRightMobile';

import cn from './style.module.sass';

type ContactsMainProps = {
    showMap: boolean;
    openMap: () => void;
    closeMap: () => void;
    currentCity: 'moscow' | 'rostov';
    setCurrentCity: Dispatch<SetStateAction<'moscow' | 'rostov'>>;
};

export default function ContactsMain({
    showMap,
    openMap,
    closeMap,
    setCurrentCity,
    currentCity,
}: ContactsMainProps) {
    const isCityActive = (city: 'moscow' | 'rostov') => {
        return currentCity === city ? cn['active'] : '';
    };

    return (
        <section className={cn['contacts']}>
            <FullWrapper>
                <h1 className={cn['contacts__title']}>Контакты</h1>
                {showMap && (
                    <div
                        role="presentation"
                        className={clsx(cn['contacts__toggle'], cn['contacts__toggle--close'])}
                        onClick={closeMap}
                    >
                        Закрыть карту
                    </div>
                )}

                <div className={cn['contacts__main-container']}>
                    <div className={cn['contacts__container-left']}>
                        <div className={cn['contacts-block']}>
                            <div className={cn['contacts-block__nav']}>
                                <div
                                    className={clsx(
                                        `${cn['contacts-block__nav-item']}  ${isCityActive(
                                            'moscow'
                                        )}`
                                    )}
                                >
                                    <div
                                        role="presentation"
                                        className={cn['contacts-block__nav-link']}
                                        onClick={() => setCurrentCity('moscow')}
                                    >
                                        Москва
                                    </div>
                                </div>
                                <div
                                    className={clsx(
                                        `${cn['contacts-block__nav-item']}  ${isCityActive(
                                            'rostov'
                                        )}`
                                    )}
                                >
                                    <div
                                        role="presentation"
                                        className={cn['contacts-block__nav-link']}
                                        onClick={() => setCurrentCity('rostov')}
                                    >
                                        Ростов-на-Дону
                                    </div>
                                </div>
                            </div>

                            <div className={cn['contacts-block__content']}>
                                {currentCity === 'moscow' && (
                                    <div className={cn['contacts-block__content-item']}>
                                        <div className={cn['contacts-block__desc']}>
                                            Московское представительство
                                        </div>
                                        <div className={cn['contacts-block__address']}>
                                            ул. Шаболовка, д. 34, стр. 3
                                        </div>
                                    </div>
                                )}
                                {currentCity === 'rostov' && (
                                    <div className={cn['contacts-block__content-item']}>
                                        <div className={cn['contacts-block__desc']}>
                                            Офис в г. Ростов-на-Дону
                                        </div>
                                        <div className={cn['contacts-block__address']}>
                                            пр. Ворошиловский, 2/2, офис&nbsp;55
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div
                                role="presentation"
                                className={clsx(
                                    cn['contacts__toggle'],
                                    cn['contacts__toggle--open']
                                )}
                                onClick={openMap}
                            >
                                Показать на карте
                            </div>
                        </div>

                        <ContactsRightMobile currentCity={currentCity} />

                        {!showMap && (
                            <div className={cn['contacts__form-container']}>
                                <ContactsBodyForm />
                            </div>
                        )}
                    </div>
                    <ContactsRight currentCity={currentCity} />
                </div>
            </FullWrapper>
        </section>
    );
}
